import { create } from "zustand";

export type DialogType = "ALERT" | "CONFIRM";

export type DialogProps = {
    isOpen: boolean;
    openAlert: (title: string, content?: string) => void;
    openConfirm: (title: string, callback: () => void, confirmButtonText?: string) => void;
    close: () => void;
    props?: {
        type: DialogType;
        title: string;
        content?: string;
        callback?: () => void;
        confirmButtonText?: string;
    };
};

export const useDialog = create<DialogProps>(set => ({
    isOpen: false,
    openAlert: (title: string, content?: string) => set({ isOpen: true, props: { title, content, type: "ALERT" } }),
    openConfirm: (title: string, callback: () => void, confirmButtonText?: string) =>
        set({
            isOpen: true,
            props: {
                title,
                callback,
                type: "CONFIRM",
                confirmButtonText,
            },
        }),
    close: () => set({ isOpen: false }),
}));
